"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathsDiff = void 0;
var getPathsDiff = function (oldStructPaths, newStructPaths) {
  var diff = [];
  var index = 0;
  for (var key in oldStructPaths) {
    if (!(key in newStructPaths)) {
      diff[index] = [key, oldStructPaths[key]];
      index++;
    }
  }
  return diff;
};
exports.getPathsDiff = getPathsDiff;